/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CarrierType } from '../model'
// @ts-ignore
import type { CarrierVisitResponse } from '../model'
// @ts-ignore
import type { CarrierVisitStatus } from '../model'
/**
 * CarrierVisitsApi - axios parameter creator
 */
export const CarrierVisitsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {Array<number>} [ids]
     * @param {CarrierType} [carrierType]
     * @param {CarrierVisitStatus} [status]
     * @param {string} [start]
     * @param {string} [end]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCarrierVisits: async (
      ids?: Array<number>,
      carrierType?: CarrierType,
      status?: CarrierVisitStatus,
      start?: string,
      end?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/CarrierVisits`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (ids) {
        localVarQueryParameter['Ids'] = ids
      }

      if (carrierType !== undefined) {
        localVarQueryParameter['CarrierType'] = carrierType
      }

      if (status !== undefined) {
        localVarQueryParameter['Status'] = status
      }

      if (start !== undefined) {
        localVarQueryParameter['Start'] =
          (start as any) instanceof Date ? (start as any).toISOString() : start
      }

      if (end !== undefined) {
        localVarQueryParameter['End'] =
          (end as any) instanceof Date ? (end as any).toISOString() : end
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CarrierVisitsApi - functional programming interface
 */
export const CarrierVisitsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CarrierVisitsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {Array<number>} [ids]
     * @param {CarrierType} [carrierType]
     * @param {CarrierVisitStatus} [status]
     * @param {string} [start]
     * @param {string} [end]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCarrierVisits(
      ids?: Array<number>,
      carrierType?: CarrierType,
      status?: CarrierVisitStatus,
      start?: string,
      end?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarrierVisitResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCarrierVisits(
        ids,
        carrierType,
        status,
        start,
        end,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CarrierVisitsApi.getCarrierVisits']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * CarrierVisitsApi - factory interface
 */
export const CarrierVisitsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CarrierVisitsApiFp(configuration)
  return {
    /**
     *
     * @param {Array<number>} [ids]
     * @param {CarrierType} [carrierType]
     * @param {CarrierVisitStatus} [status]
     * @param {string} [start]
     * @param {string} [end]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCarrierVisits(
      ids?: Array<number>,
      carrierType?: CarrierType,
      status?: CarrierVisitStatus,
      start?: string,
      end?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CarrierVisitResponse>> {
      return localVarFp
        .getCarrierVisits(ids, carrierType, status, start, end, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * CarrierVisitsApi - object-oriented interface
 */
export class CarrierVisitsApi extends BaseAPI {
  /**
   *
   * @param {Array<number>} [ids]
   * @param {CarrierType} [carrierType]
   * @param {CarrierVisitStatus} [status]
   * @param {string} [start]
   * @param {string} [end]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getCarrierVisits(
    ids?: Array<number>,
    carrierType?: CarrierType,
    status?: CarrierVisitStatus,
    start?: string,
    end?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return CarrierVisitsApiFp(this.configuration)
      .getCarrierVisits(ids, carrierType, status, start, end, options)
      .then(request => request(this.axios, this.basePath))
  }
}
